import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import useAxios from "@hooks/use-axios";
import { SUPERADMIN_ENDPOINTS } from "../misc/constants";
import { opsAccountDefaults, opsAccountSchema } from "../misc/schema";
import { toRecord } from "../misc/response";

// One call, POST /ops/v1 — no listing, no edit, no delete. It is the console's
// first step: the account that everything after it is created as.
const useOpsAccount = () => {
    const { axiosInstance, loading } = useAxios({ base: "base", alertTypeOnSuccess: "toast" });
    // The API never returns a password again, so the ones set here are held on
    // screen until the page is left — otherwise there is no way to hand the new
    // user their credentials.
    const [created, setCreated] = useState([]);

    const methods = useForm({
        resolver     : yupResolver(opsAccountSchema),
        defaultValues: opsAccountDefaults
    });

    const submit = methods.handleSubmit(async (values) => {
        const res = await axiosInstance.post(SUPERADMIN_ENDPOINTS.OPS_ACCOUNTS, {
            name    : values.name,
            email   : values.email,
            password: values.password
        });
        const record = toRecord(res) || {};
        setCreated((current) => [
            {
                _id     : record._id || values.email,
                name    : record.name || values.name,
                email   : record.email || values.email,
                password: values.password
            },
            ...current
        ]);
        methods.reset(opsAccountDefaults);
    });

    const dismissCreated = (id) => setCreated((current) => current.filter((row) => row._id !== id));

    return { methods, loading, submit, created, dismissCreated };
};

export default useOpsAccount;
